import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuCard } from "../../components/neu/Neu";
import { customSalaryReport, salaryReport } from "../../api/payroll";
import { attendanceReport } from "../../api/attendanceReport";
import { PeriodChip } from "./PeriodChip";
import { SalaryDetails } from "./SalaryDetails";
import { AttendanceDetails } from "../attendance/AttendanceDetails";

// تفاصيل التقرير المختار تُعرض مباشرة (بلا أزرار إظهار) — الطباعة من زر PDF في الأعلى.
export const ReportDetailsCard = ({ filters, kind }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [data, setData] = useState(null);
  const custom = Boolean(filters.start && filters.end);

  useEffect(() => {
    const scope = {
      lang,
      ...(filters.branch_id && filters.branch_id !== "all" ? { branch_id: filters.branch_id } : {}),
      ...(filters.user_id && filters.user_id !== "all" ? { user_id: filters.user_id } : {}),
    };
    if (!filters.branch_id || !filters.user_id) return setData(null);
    (async () => {
      try {
        const payload = kind === "salary"
          ? custom
            ? await customSalaryReport({ start: filters.start, end: filters.end, ...scope })
            : await salaryReport({ month: filters.month, ...scope })
          : await attendanceReport({
              month: custom ? filters.start.slice(0, 7) : filters.month,
              ...(custom ? { start: filters.start, end: filters.end } : {}),
              ...scope,
            });
        setData(payload);
      } catch {
        toast.error(t("errors.generic"));
        setData(null);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind, lang, filters.month, filters.start, filters.end, filters.branch_id, filters.user_id]);

  if (!filters.branch_id || !filters.user_id) {
    return (
      <p className="rounded-3xl bg-background p-6 text-center text-sm font-bold text-muted-foreground shadow-neu-in"
         data-testid="report-pick-hint">
        {t("payrollFilters.pickFirst")}
      </p>
    );
  }

  return (
    <NeuCard className="grid gap-4" data-testid="report-details-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="label-xs">{t(`reportDetails.${kind}`)}</p>
        <PeriodChip filters={filters} />
      </div>
      {!data ? (
        <p className="text-sm text-muted-foreground" data-testid="report-details-empty">
          {t("salaryReport.noData")}
        </p>
      ) : kind === "salary" ? (
        <SalaryDetails data={data} lang={lang} />
      ) : (
        <AttendanceDetails data={data} lang={lang} />
      )}
    </NeuCard>
  );
};
